module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_2.865d7d1b.png";